var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInductionSecondary = function SvgInductionSecondary(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 192,
    viewBox: "0 0 340 192",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "103.4%",
    height: "154.2%",
    x: "-1.7%",
    y: "-18.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M21.108 187c-5.602.004-10.975-2.252-14.934-6.27-3.96-4.017-6.181-9.467-6.174-15.147C0 164.156 1.14 163 2.547 163h316.906c1.407 0 2.547 1.156 2.547 2.583.004 5.679-2.219 11.126-6.178 15.143-3.959 4.017-9.33 6.274-14.93 6.274H21.108z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 186,
    x: 27,
    fill: "#67748A",
    fillRule: "nonzero",
    rx: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.38,
    height: 17.42,
    x: 1.179,
    y: 51.824,
    fill: "#FFCF5C",
    fillRule: "nonzero",
    rx: 2.9,
    transform: "rotate(5.9 19.369 60.534)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.38,
    height: 17.42,
    x: 1.193,
    y: 77.539,
    fill: "#7DDFC3",
    fillRule: "nonzero",
    rx: 2.9,
    transform: "rotate(-3.18 19.383 86.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.38,
    height: 17.42,
    x: 1.183,
    y: 104.142,
    fill: "#FDAFBB",
    fillRule: "nonzero",
    rx: 2.9,
    transform: "rotate(-9.45 19.373 112.852)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DAF8",
    fillRule: "nonzero",
    d: "M43.355 172.647c-.371 0-.726-.151-.982-.42-.256-.268-.39-.63-.371-1l.88-156.874c0-.747.605-1.353 1.352-1.353l234.413 1.353c.747 0 1.353.606 1.353 1.353l-.866 156.941c0 .747-.606 1.353-1.353 1.353l-234.426-1.353z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 189.44,
    height: 114.45,
    x: 65.318,
    y: 35.682,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 1.06,
    transform: "rotate(.32 160.038 92.907)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    fillRule: "nonzero",
    d: "M254.687 39.79l-188.65-1c-.106 0-.206-.042-.28-.118-.073-.075-.113-.177-.11-.282l.08-15c0-.105.042-.206.117-.28.076-.073.177-.113.283-.11l188.65 1c.105 0 .206.043.279.118.073.075.113.177.11.282l-.08 15c-.01.215-.184.385-.4.39z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 31,
    r: 4,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C48C",
    fillRule: "nonzero",
    d: "M89 31c0 1.618-.975 3.076-2.47 3.695-1.494.62-3.214.277-4.358-.867-1.144-1.144-1.487-2.864-.867-4.359C81.924 27.975 83.382 27 85 27c2.21 0 4 1.79 4 4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 31,
    r: 4,
    fill: "#F9690E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC19C",
    fillRule: "nonzero",
    d: "M77.407 83.19c-1.423-.005-2.575-1.157-2.58-2.58.005-1.422 1.157-2.574 2.58-2.58h33.69c1.422.006 2.574 1.158 2.58 2.58-.006 1.423-1.158 2.575-2.58 2.58h-33.69zM216.886 91.282c-1.666-1.238-3.947-1.238-5.613 0l-11.823 8.865-15.617-19.199-.195-.215c-1.765-1.768-4.608-1.835-6.455-.152l-14.569 16.06V69.008c.003-2.425 1.968-4.39 4.393-4.393h54.844c2.424.003 4.389 1.968 4.392 4.393V98.3l-9.357-7.018zM221.85 59h-54.844c-5.525.005-10.002 4.482-10.007 10.007v45.486c.005 5.525 4.482 10.002 10.007 10.007h54.844c5.524-.005 10.001-4.482 10.006-10.007V69.007c-.005-5.525-4.482-10.002-10.006-10.007zm-8.708 17.779c-1.338 0-2.573.714-3.242 1.872-.668 1.159-.668 2.586.001 3.744.67 1.158 1.905 1.871 3.243 1.871 2.067 0 3.743-1.677 3.743-3.745 0-2.067-1.678-3.743-3.745-3.742M122.157 83.19h-2.52c-1.423-.005-2.575-1.157-2.58-2.58.005-1.422 1.157-2.574 2.58-2.58h2.52c1.422.006 2.574 1.158 2.58 2.58-.006 1.423-1.158 2.575-2.58 2.58zM122.157 95.5h-2.52c-1.423-.005-2.575-1.157-2.58-2.58.005-1.422 1.157-2.574 2.58-2.58h2.52c1.422.006 2.574 1.158 2.58 2.58-.006 1.423-1.158 2.575-2.58 2.58zM88.347 96.05h-10.94c-1.411-.005-2.559-1.139-2.58-2.55.005-1.422 1.157-2.574 2.58-2.58h10.94c1.422.006 2.574 1.158 2.58 2.58-.022 1.411-1.17 2.545-2.58 2.55zM108.497 96.05h-10.94c-1.411-.005-2.559-1.139-2.58-2.55-.006-.689.263-1.35.748-1.84.484-.49 1.143-.767 1.832-.77h10.94c.688.003 1.347.28 1.832.77.484.49.753 1.151.748 1.84-.022 1.411-1.17 2.545-2.58 2.55zM123.357 108.91h-45.95c-1.423-.005-2.575-1.157-2.58-2.58.005-1.422 1.157-2.574 2.58-2.58h46c1.422.006 2.574 1.158 2.58 2.58-.003.692-.283 1.355-.777 1.84-.494.484-1.161.75-1.853.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF647C",
    fillRule: "nonzero",
    d: "M325.691 29.704l1.153 10.085c.899 7.863-4.747 14.965-12.61 15.864l-44.123 5.043-.251.025-12.66 7.71c-.826.507-1.859.51-2.683.023l-.162-.104c-.794-.553-1.212-1.498-1.096-2.448l.03-.19 2.461-12.672c-.777-1.504-1.3-3.172-1.503-4.954L253.094 38c-.899-7.863 4.747-14.966 12.61-15.864l44.123-5.043c7.863-.899 14.966 4.747 15.864 12.61zm-56.83 7.185l-.212.003-.212.013c-2.457.204-4.34 2.308-4.248 4.797l.014.211c.214 2.45 2.313 4.327 4.796 4.239l.212-.013c2.454-.21 4.336-2.31 4.248-4.797l-.013-.212c-.21-2.453-2.312-4.331-4.797-4.238zm21.13-2.63l-.212.003-.217.014c-2.445.222-4.315 2.317-4.233 4.796l.014.211c.214 2.45 2.313 4.327 4.796 4.239l.212-.013c2.453-.21 4.331-2.312 4.238-4.797l-.013-.212c-.21-2.453-2.312-4.331-4.797-4.238zm19.956-2.01l-.218.003-.211.014c-2.45.214-4.327 2.313-4.239 4.796l.013.211c.21 2.453 2.312 4.332 4.797 4.239l.212-.014c2.45-.214 4.326-2.313 4.238-4.796l-.014-.217c-.222-2.445-2.317-4.315-4.796-4.233z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C48C",
    d: "M18.012.108l67.143 8.101c8.098.977 13.871 8.335 12.894 16.433l-1.47 12.192c-.978 8.098-8.335 13.871-16.434 12.894L21.657 42.67 7.272 51.64c-.723.445-1.627.461-2.361.053l-.155-.094c-.76-.502-1.159-1.398-1.024-2.299l1.693-10.898C1.645 35.307-.52 30.404.108 25.194l1.47-12.192C2.557 4.904 9.914-.869 18.013.108z",
    transform: "translate(238 83)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.672 22.79l-54.87-6.88c-1.682-.213-2.876-1.746-2.67-3.43.214-1.678 1.74-2.87 3.42-2.67l54.88 6.88c1.679.219 2.867 1.75 2.66 3.43-.213 1.679-1.74 2.87-3.42 2.67zM77.952 38.54l-54.87-6.88c-1.673-.213-2.864-1.734-2.67-3.41.214-1.682 1.747-2.876 3.43-2.67l54.87 6.88c1.683.214 2.877 1.747 2.67 3.43-.223 1.675-1.753 2.857-3.43 2.65z",
    transform: "translate(238 83)"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#67748A",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DAF8",
    fillRule: "nonzero",
    d: "M199.68 169h-77.36c-4.595 0-8.32-2.239-8.32-5h94c-.007 2.76-3.728 4.996-8.32 5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInductionSecondary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inductionSecondary.5edf3321.svg";
export { ForwardRef as ReactComponent };